<template>
  <div>
    <span class="iv-fc-65 iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list" @click="expandParent('view', item)">
      查看详情
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  }
}
</script>
